import type { RouteObject } from "react-router-dom";
import Dashboard from "@/config/deployment/DashboardEntry";
import Models from "@/pages/common/Models";
import Settings from "@/pages/common/Settings";
import Users from "@/pages/common/Users";

export const commonRoutes: RouteObject[] = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/settings", element: <Settings /> },
  { path: "/users", element: <Users /> },
  {
    path: "/plugins/models",
    element: <Models />,
  },
];
